import React, {
  useState, useCallback, useMemo, useEffect
} from 'react';
import PropTypes from 'prop-types';

import { langType, surveyTypeValues } from '../../../constants/types';
import { MultiSelect } from '../../Select';
import SurveyPartTypeSelect from '../SurveyPartTypeSelect';
import LabelWrapper from '../../LabelWrapper';
import { withLang } from '../../../i18n';
import styles from './surveyPartSearch.module.css';
import { objHasKey } from '../../../util';
import TextInput from '../../TextInput';

const makeFilterOptions = (t) => ([
  { value: 'selfCreated', label: t('surveySchemaParts.search.filterOptions.selfMade') }
]);

const SurveyPartSearch = ({ onChange, defaultCriteria, translate: t }) => {
  const [criteria, setCriteria] = useState(defaultCriteria);

  useEffect(() => {
    setCriteria(defaultCriteria);
  }, [defaultCriteria]);

  const filterOptions = useMemo(() => makeFilterOptions(t), [t]);

  const update = useCallback((patch) => {
    setCriteria((prev) => {
      const next = { ...prev, ...patch };
      onChange(next);
      return next;
    });
  }, [onChange]);

  const showType = objHasKey(defaultCriteria, 'type');
  const showKeyword = objHasKey(defaultCriteria, 'keyword');
  const showFilters = objHasKey(defaultCriteria, 'filters');

  return (
    <div className={styles.searchContainer}>
      <h4>{t('surveySchemaParts.search.heading')}</h4>
      {showType && (
      <div className={styles.row}>
        <SurveyPartTypeSelect
          selectedType={criteria.type}
          onChange={(value) => update({ type: value })}
        />
      </div>
      )}

      {(showKeyword || showFilters) && (
        <div className={styles.row}>
          {showKeyword && (
            <div className={`${styles.searchElement}`}>
              <LabelWrapper label={t('surveySchemaParts.search.titleSearch')}>
                <TextInput
                  value={criteria.keyword}
                  onChange={(e) => update({ keyword: e.target.value })}
                  maxLength={255}
                  minLength={2}
                  data-cy="search-survey-part-by-name-input"
                />
              </LabelWrapper>
            </div>
          )}

          {showFilters && (
            <div className={`${styles.searchElement}`}>
              <LabelWrapper label={t('surveySchemaParts.search.filter')} dataCy="survey-part-filter-search">
                <MultiSelect
                  options={filterOptions}
                  value={criteria.filters}
                  placeholderKey="common.select"
                  onChange={(vals) => update({ filters: vals })}
                />
              </LabelWrapper>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const {
  shape, func, oneOf, arrayOf, string
} = PropTypes;
SurveyPartSearch.propTypes = {
  onChange: func.isRequired,
  defaultCriteria: shape({
    type: oneOf(Object.values(surveyTypeValues)).isRequired,
    keyword: string,
    filters: arrayOf(string)
  }).isRequired,
  ...langType
};

export default withLang(SurveyPartSearch);
